var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.02981 7.95001C4.10269 8.66388 4.67933 9.24074 5.39286 9.31689C5.81298 9.36171 6.24284 9.39754 6.68021 9.39754C7.11759 9.39754 7.54745 9.36171 7.96756 9.31689C8.6811 9.24074 9.25773 8.66388 9.33062 7.95001C9.37325 7.53255 9.40681 7.10547 9.40681 6.67093C9.40681 6.2364 9.37325 5.8093 9.33062 5.39186C9.25773 4.67799 8.6811 4.10113 7.96756 4.02499C7.54745 3.98016 7.11759 3.94434 6.68021 3.94434C6.24284 3.94434 5.81298 3.98016 5.39286 4.02499C4.67933 4.10113 4.10269 4.67799 4.02981 5.39186C3.98718 5.8093 3.95361 6.2364 3.95361 6.67093C3.95361 7.10547 3.98718 7.53255 4.02981 7.95001Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9739 0.5C14.5248 0.559355 15.0709 0.622981 15.6115 0.685638C17.0372 0.850876 18.1747 1.98766 18.3349 3.41386C18.3952 3.95105 18.456 4.49358 18.5125 5.041",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9739 18.5001C14.5248 18.4406 15.0709 18.377 15.6115 18.3143C17.0372 18.1491 18.1747 17.0123 18.3349 15.5861C18.3952 15.049 18.456 14.5065 18.5125 13.959",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03865 0.5C4.48763 0.559355 3.94158 0.622981 3.40092 0.685638C1.97529 0.850876 0.837753 1.98766 0.677641 3.41386C0.617332 3.95105 0.556522 4.49358 0.5 5.041",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03865 18.5001C4.48763 18.4406 3.94158 18.377 3.40092 18.3143C1.97529 18.1491 0.837753 17.0123 0.677641 15.5861C0.617332 15.049 0.556522 14.5065 0.5 13.959",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.45117 12.7881V15.0586H6.6799",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9985 15.0596V12.7891H12.7698",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0396 9.4668H12.8108",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40674 15.0383V12.8096",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9985 6.67088V4.40039H12.7698",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.3a6d619d541d850b0b33c6f74a7d1cc2.svg";
export { ForwardRef as ReactComponent };